import { render, staticRenderFns } from "./DetectionHistory.vue?vue&type=template&id=08b86364&scoped=true&"
import script from "./DetectionHistory.vue?vue&type=script&lang=js&"
export * from "./DetectionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DetectionHistory.vue?vue&type=style&index=0&id=08b86364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b86364",
  null
  
)

export default component.exports